import { Injector } from '@angular/core';
import { CompanyMarketEntity } from '../entity-classes/company-market-entity';
import { IComponentEditorEntity } from '../entity-interfaces/editor-entity.interface';
import { IEntity } from '../entity-interfaces/entity.interface';

import { BidCategoryService } from '@http/clients/bid-category.service';
import { BuildingContactRoleService } from '@http/clients/building-contact-role.service';
import { MarketService } from '@http/clients/market.service';
import { ProductTypeService } from '@http/clients/product-type.service';
import { TagService } from '@http/clients/tag.service';
import { UserRoleService } from '@http/clients/user-role.service';
import { AccountMarketEntity } from '../entity-classes/account-market-entity';
import { AccountProductTypeEntity } from '../entity-classes/account-product-type-entity';
import { BuildingProductTypeEntity } from '../entity-classes/building-product-type-entity';
import { OpportunityBidCategoryEntity } from '../entity-classes/opportunity-bid-category-entity';
import { OpportunityBuildingContactRoleEntity } from '../entity-classes/opportunity-building-contact-role-entity';
import { OpportunityMarketEntity } from '../entity-classes/opportunity-market-entity';
import { OpportunityProductTypeEntity } from '../entity-classes/opportunity-product-type-entity';
import { OpportunityTagEntity } from '../entity-classes/opportunity-tag-entity';
import { OpportunityUserRoleEntity } from '../entity-classes/opportunity-user-role-entity';
import { Entity } from '../entity-enums/entity';

export class EntityFactory {
    static create(entityId: string, injector: Injector): IComponentEditorEntity<IEntity, unknown> {
        switch (entityId) {
            case Entity.companyMarket:
                return new CompanyMarketEntity(injector.get(MarketService));

            case Entity.accountMarket:
                return new AccountMarketEntity(injector.get(MarketService));

            case Entity.opportunityMarket:
                return new OpportunityMarketEntity(injector.get(MarketService));

            case Entity.opportunityTag:
                return new OpportunityTagEntity(injector.get(TagService));

            case Entity.opportunityProductType:
                return new OpportunityProductTypeEntity(injector.get(ProductTypeService));

            case Entity.buildingProductType:
                return new BuildingProductTypeEntity(injector.get(ProductTypeService));

            case Entity.accountProductType:
                return new AccountProductTypeEntity(injector.get(ProductTypeService));

            case Entity.opportunityBuildingContactRole:
                return new OpportunityBuildingContactRoleEntity(injector.get(BuildingContactRoleService));

            case Entity.opportunityBidCategory:
                return new OpportunityBidCategoryEntity(injector.get(BidCategoryService));

            case Entity.opportunityUserRole:
                return new OpportunityUserRoleEntity(injector.get(UserRoleService));

            default:
                throw new Error('Entity id not recognized as a valid entity type');
        }
    }
}
